import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19 4h.5a3.492 3.492 0 0 1 3.022 1.733c.311.532.478 1.138.478 1.767-.013 1.68-.013 3.68 0 6.006a52.594 52.594 0 0 1-.222 4.996 3.5 3.5 0 0 1-3.246 3.179c-3.274.224-5.775.337-7.507.337-1.733 0-4.248-.113-7.548-.338a3.5 3.5 0 0 1-3.249-3.185A56.93 56.93 0 0 1 1 13.51V7.5c0-.628.167-1.234.478-1.766a3.515 3.515 0 0 1 1.255-1.255A3.486 3.486 0 0 1 4.5 4H5v-.5a1.5 1.5 0 1 1 3 0V4h8v-.5a1.5 1.5 0 0 1 3 0V4Zm-.085 1a1.5 1.5 0 0 1-2.83 0h-8.17a1.5 1.5 0 0 1-2.83 0H4.5a2.493 2.493 0 0 0-2.159 1.239c-.222.379-.341.81-.341 1.26v6.01c0 1.564.075 3.197.224 4.898a2.5 2.5 0 0 0 2.32 2.276c3.28.223 5.775.335 7.481.335 1.705 0 4.185-.112 7.438-.335a2.5 2.5 0 0 0 2.32-2.27c.153-1.712.226-3.345.217-4.901a457.112 457.112 0 0 1 0-6.014c0-.45-.12-.88-.341-1.26a2.515 2.515 0 0 0-.898-.897A2.486 2.486 0 0 0 19.5 5h-.585ZM17.5 3a.5.5 0 0 0-.5.5v1a.5.5 0 1 0 1 0v-1a.5.5 0 0 0-.5-.5Zm-11 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5Zm-1 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-13Zm13-1h-13A1.5 1.5 0 0 0 4 9.5v8A1.5 1.5 0 0 0 5.5 19h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 18.5 8Zm-9 .297a.5.5 0 0 0-.5.5V13H5a.5.5 0 1 0 0 1h4v4.166a.5.5 0 0 0 1 0V14h4v4.166a.5.5 0 0 0 1 0V14h4a.5.5 0 0 0 0-1h-4V8.797a.5.5 0 1 0-1 0V13h-4V8.797a.5.5 0 0 0-.5-.5Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M9 9h1v-.203a.5.5 0 0 0-1 0V9Zm6 0v-.203a.5.5 0 1 0-1 0V9h1Zm4 4v1a.5.5 0 0 0 0-1Zm-4 5h-1v.166a.5.5 0 0 0 1 0V18Zm-6 0v.166a.5.5 0 0 0 1 0V18H9Zm-4-4v-1a.5.5 0 1 0 0 1Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.915 5a1.5 1.5 0 0 1-2.83 0h-8.17a1.5 1.5 0 0 1-2.83 0H4.5a2.493 2.493 0 0 0-2.159 1.239c-.222.379-.341.81-.341 1.26v6.01c0 1.564.075 3.197.224 4.898a2.5 2.5 0 0 0 2.32 2.276c3.28.223 5.775.335 7.481.335 1.705 0 4.185-.112 7.438-.335a2.5 2.5 0 0 0 2.32-2.27c.153-1.712.226-3.345.217-4.901a457.112 457.112 0 0 1 0-6.014c0-.45-.12-.88-.341-1.26a2.515 2.515 0 0 0-.898-.897A2.486 2.486 0 0 0 19.5 5h-.585ZM18.5 8h-13A1.5 1.5 0 0 0 4 9.5v8A1.5 1.5 0 0 0 5.5 19h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 18.5 8Z",
      clipRule: "evenodd"
    }
  )
);
var SvgCalendarFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CalendarFilled_default = SvgCalendarFilled;

export { CalendarFilled_default as default };
